<div class="modal-heading">
  <div class="close-button invisible"></div>
  <div class="header-section">
    <span class="header-text"
      >Bank Statement Details ({{ data?.pincode ? data.pincode + ', ' : '' }}{{ data?.district }})
{{ bankDetails.length ? '[' + bankDetails.length + ']' : '' }}</span
    >
    @if (bankDetails.length) {
      <button type="button" class="dp-secondary-btn" style="height: 3.5vh;" (click)="exportData()">
        Export Excel
      </button>
    }
  </div>
  <div class="close-button" (click)="closeDialog()">
    <mat-icon class="close-icon">close</mat-icon>
  </div>
</div>

<div class="modal-body">
  <div style="margin-top: 20px"></div>
<div class="table-container">
    
    <table class="table">
     
        <thead class="table-head">
            <tr>

                <th>
                    <span>Txn. date</span>
                </th>
                <th>
                    <span>Txn. ID</span>
                </th>
                <th>
                    <span>Amount</span>
                </th>
                <th>
                    <span>Txn. details</span>
                </th>
                <th>
                    <span>Bank Name</span>
                </th>
                <th>
                    <span>IFSC Code</span>
                </th>
                <th>
                    <span>Branch</span>
                </th>
                <th>
                    <span>City</span>
                </th>
                <th>
                    <span>Pincode</span>
                </th>
                <th>
                    <span>Action</span>
                </th>
               
            </tr>
        </thead>
        
        <tbody class="table-body">
            @if(bankDetails.length > 0){
            @for(row of bankDetails; track row){
            <tr>
               
                <td>
                    {{row.txnDate}}
                </td>
                <td>
                    {{row.txnId}}
                </td>
                <td>
                    {{row.txnAmount}}
                </td>
                <td>
                    {{row.txnDesc}}
                </td>
                <td>
                    {{row.txnBranch.bank_name}}
                </td>
                <td>
                    {{row.txnBranch.ifsc}}
                </td>
                <td>
                    {{row.txnBranch.branch_name}}
                </td>
                <td>
                    {{row.txnBranch.city}}
                </td>
                <td>
                    {{row.txnBranch.pincode}}
                </td>
                <td>
                    @if (row.traceDetails) {
                <img src="../../../assets/images/checkbox-circle-line-selected.svg" title="Uplod Complete" alt="close icon" class="tick-btn"/>
                    }@else {
                <img (click)="onClickDocx(row,$event)" src="../../../assets/images/sticky-note-add-line.svg" title="Uplod Sleeves" alt="view" class="Upload-doc-icon"/>
                    }
                </td>

            </tr>
        }
            
    
            }@else{
            <tr>
                <td colspan="5" style="text-align: center;">
                    No Records Found
                </td>
            </tr>
            }
           
        </tbody>
    </table>
</div>
</div>